// Ported from project/assets/clients-data.js — one row per CLIENT.
// Clients have multiple matters; matterIds[] cross-references matters.ts.

import type { Client } from "./types";

export const CLIENTS: Record<string, Client> = {
  "cl-anvar": {
    id: "cl-anvar",
    name: "Anvar Kasymov",
    altSpellings: ["Kasymov, Anvar", "Kasimov Anvar"],
    primaryLanguage: "Uzbek",
    secondaryLanguage: "Russian",
    contactEmail: "anvar.kasymov@example.com",
    contactPhone: "+1 (267) 555-0144",
    nationality: "Uzbekistan",
    matterIds: ["DL-YJF4Q5", "DL-K2P9XM"],
    intakeDate: "2025-08-14",
    notes: "Defensive asylum + U-visa for cooperation with Phila PD on robbery investigation",
  },
  "cl-colmenares": {
    id: "cl-colmenares",
    name: "María B. Colmenares",
    altSpellings: ["Colmenares, María", "Maria Colmenares"],
    primaryLanguage: "Spanish",
    contactEmail: "maria.colmenares.r@gmail.com",
    contactPhone: "+1 (215) 555-0289",
    nationality: "Venezuela",
    matterIds: ["DL-MC7K2Q", "DL-MC9R3T"],
    intakeDate: "2024-09-22",
    notes:
      "Spanish-only; primary contact is the client (no spouse on case 1, divorcing spouse on case 2)",
  },
  "cl-akmatbekov": {
    id: "cl-akmatbekov",
    name: "Adilet Akmatbekov",
    altSpellings: ["Akmatbekov, Adilet", "Акматбеков Адилет"],
    primaryLanguage: "Russian",
    secondaryLanguage: "Kyrgyz",
    contactEmail: "adilet.akmatbekov@gmail.com",
    contactPhone: "+1 (267) 555-0331",
    nationality: "Kyrgyzstan",
    matterIds: ["DL-AA8R4T", "DL-AA2J5N"],
    intakeDate: "2025-10-19",
    notes:
      "Criminal case w/ immigration consequences — Padilla advisory + parallel removal defense",
  },
  "cl-kovalenko": {
    id: "cl-kovalenko",
    name: "Olena Kovalenko",
    altSpellings: ["Kovalenko, Olena", "Коваленко Олена"],
    primaryLanguage: "Ukrainian",
    contactEmail: "o.kovalenko.ua@gmail.com",
    contactPhone: "+1 (215) 555-0418",
    nationality: "Ukraine",
    matterIds: ["DL-T2VC4M"],
    intakeDate: "2025-11-03",
  },
  "cl-mendez": {
    id: "cl-mendez",
    name: "Carlos Mendez",
    altSpellings: ["Mendez, Carlos"],
    primaryLanguage: "Spanish",
    contactEmail: "carlos.mendez83@gmail.com",
    contactPhone: "+1 (215) 555-0501",
    nationality: "Mexico",
    matterIds: ["DL-FH3JQ8"],
    intakeDate: "2024-06-12",
  },
  "cl-zhang": {
    id: "cl-zhang",
    name: "Wei Zhang",
    altSpellings: ["Zhang, Wei", "张伟"],
    primaryLanguage: "Mandarin",
    secondaryLanguage: "English",
    contactEmail: "wei.zhang.dev@gmail.com",
    contactPhone: "+1 (215) 555-0617",
    nationality: "China",
    matterIds: ["DL-Z7WB6V"],
    intakeDate: "2024-04-08",
  },
  "cl-petrov": {
    id: "cl-petrov",
    name: "Andrei Petrov",
    altSpellings: ["Petrov, Andrei", "Петров Андрей"],
    primaryLanguage: "Russian",
    contactEmail: "a.petrov.usa@gmail.com",
    contactPhone: "+1 (215) 555-0723",
    nationality: "Russia",
    matterIds: ["DL-MW5N9X"],
    intakeDate: "2024-12-01",
  },
  "cl-garcia": {
    id: "cl-garcia",
    name: "Maria Garcia",
    altSpellings: ["Garcia, Maria"],
    primaryLanguage: "Spanish",
    contactEmail: "maria.garcia.honduras@gmail.com",
    contactPhone: "+1 (215) 555-0844",
    nationality: "Honduras",
    matterIds: ["DL-K8RT2P"],
    intakeDate: "2024-08-19",
  },
  "cl-rsmith": {
    id: "cl-rsmith",
    name: "Robert Smith",
    altSpellings: ["Smith, Robert"],
    primaryLanguage: "English",
    contactEmail: "rsmith.philly@gmail.com",
    contactPhone: "+1 (267) 555-0921",
    nationality: "USA",
    matterIds: ["DL-RS6X9P"],
    intakeDate: "2025-02-14",
  },
  "cl-bealick": {
    id: "cl-bealick",
    name: "Vera Bealick",
    altSpellings: ["Bealick, Vera"],
    primaryLanguage: "English",
    secondaryLanguage: "Russian",
    contactEmail: "vera.bealick@gmail.com",
    contactPhone: "+1 (215) 555-1018",
    nationality: "USA (originally USSR)",
    matterIds: ["DL-BL3M7K"],
    intakeDate: "2026-01-08",
  },
  "cl-aleixo": {
    id: "cl-aleixo",
    name: "Edilson Aleixo dos Santos",
    altSpellings: ["Aleixo, Edilson", "Aleixo dos Santos"],
    primaryLanguage: "Portuguese",
    contactEmail: "edilson.aleixo@gmail.com",
    contactPhone: "+1 (215) 555-1144",
    nationality: "Brazil",
    matterIds: ["DL-EA8K2N"],
    intakeDate: "2026-02-20",
  },
  "cl-divgun": {
    id: "cl-divgun",
    name: "Stanislav Divgun",
    altSpellings: ["Divgun, Stanislav"],
    primaryLanguage: "Russian",
    contactEmail: "s.divgun@gmail.com",
    contactPhone: "+1 (267) 555-1207",
    nationality: "Belarus",
    matterIds: ["DL-SD2W6V"],
    intakeDate: "2026-02-14",
  },
  "cl-ahmedov": {
    id: "cl-ahmedov",
    name: "Khurshed Ahmedov",
    altSpellings: ["Ahmedov, Khurshed"],
    primaryLanguage: "Tajik",
    secondaryLanguage: "Russian",
    contactEmail: "khurshed.ahmedov@gmail.com",
    contactPhone: "+1 (215) 555-1339",
    nationality: "Tajikistan",
    matterIds: ["DL-KA9Y3F"],
    intakeDate: "2024-09-15",
  },
  "cl-norimov": {
    id: "cl-norimov",
    name: "Daler Norimov",
    altSpellings: ["Norimov, Daler"],
    primaryLanguage: "Tajik",
    secondaryLanguage: "Russian",
    contactEmail: "d.norimov@gmail.com",
    contactPhone: "+1 (267) 555-1452",
    nationality: "Tajikistan",
    matterIds: ["DL-DN4T8H"],
    intakeDate: "2026-04-15",
  },
  "cl-abele": {
    id: "cl-abele",
    name: "Suzanne Abele",
    altSpellings: ["Abele, Suzanne"],
    primaryLanguage: "English",
    contactEmail: "suzanne.abele@gmail.com",
    contactPhone: "+1 (215) 555-1561",
    nationality: "USA",
    matterIds: ["DL-SA7B4M"],
    intakeDate: "2025-06-10",
    notes:
      "Plaintiff in civil suit vs. Citizens Bank — financial-services consumer protection case",
  },
  "cl-belovol": {
    id: "cl-belovol",
    name: "Yelena Belovol",
    altSpellings: ["Belovol, Yelena", "Беловол Елена"],
    primaryLanguage: "Russian",
    contactEmail: "y.belovol@gmail.com",
    contactPhone: "+1 (215) 555-1672",
    nationality: "Ukraine",
    matterIds: ["DL-YB2V8K"],
    intakeDate: "2025-12-04",
  },
  "cl-sobel-ref-001": {
    id: "cl-sobel-ref-001",
    name: "Mamuka Shalikiani",
    altSpellings: ["Shalikiani, Mamuka"],
    primaryLanguage: "Georgian",
    secondaryLanguage: "Russian",
    contactEmail: "m.shalikiani@gmail.com",
    contactPhone: "+1 (215) 555-1783",
    nationality: "Georgia",
    matterIds: ["DL-MS3X9P"],
    intakeDate: "2026-02-24",
    notes: "Sobel of-counsel referral — Third Circuit habeas appeal from W.D. Pa.",
  },
};

export const clientById = (id: string): Client | null => CLIENTS[id] ?? null;
